export const SNAPINSIGHT_PASSWORD_PATTERN =
  /^(?=.{8,256}$)(?:(?=(?:.*[a-z]))(?=(?:.*[A-Z]))(?=(?:.*\d))|(?=(?:.*[a-z]))(?=(?:.*[A-Z]))(?=(?:.*[^A-Za-z0-9]))|(?=(?:.*[a-z]))(?=(?:.*\d))(?=(?:.*[^A-Za-z0-9]))|(?=(?:.*[A-Z]))(?=(?:.*\d))(?=(?:.*[^A-Za-z0-9]))).+$/;
